import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { processReservationCart } from 'redux/reservationCart/actions';

class Process extends Component {
  handleProcess = (e) => {
    e.preventDefault();
    const { props } = this;
    if (props.reservationCart.customerId) {
      const successFunction = (reservation) => {
        props.history.push(`/reservation/checkout/receipt/${reservation.id}`);
      };
      props.processReservationCart(successFunction);
    } else {
      const successFunction = (reservation) => {
        props.history.push(
          `/reservation/checkout/receipt?reservationNumber=${
            reservation.reservationNumber
          }&email=${encodeURIComponent(props.reservationCart.email)}`
        );
      };
      props.processReservationCart(successFunction);
    }
  };

  render() {
    return (
      <div className="c7-checkout__content__buttons">
        <button
          type="button"
          className="c7-button"
          onClick={this.handleProcess}
        >
          Complete Reservation
        </button>
      </div>
    );
  }
}

export default withRouter(connect(null, { processReservationCart })(Process));
